import React from "react";
import { Modal, Button, Row, Col, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import StatusBadge from "./StatusBadge";
export default function RecapResa({ reservationList, show = true, onClose }) {
  const navigate = useNavigate();
  if (!reservationList) return null;

  const {
    name,
    firstname,
    email,
    phone,
    depart,
    arrivee,
    date,
    heure,
    serviceType,
    options,
    passagers,
    bagages,
    distance,
    duree,
    prix,
    demandes,
    status,
  } = reservationList;

  const optionLabels = [
    { key: "wifi", label: "WiFi" },
    { key: "cafe", label: "Café" },
    { key: "eau", label: "Eau" },
  ];

  const activeOptions = optionLabels.filter((o) => options?.[o.key]);

  return (
    <Modal show={show} centered size="lg" dialogClassName="recap-modal">
      <Modal.Header closeButton>
        <Modal.Title>Récapitulatif de la réservation</Modal.Title>
        <StatusBadge status={status} />
      </Modal.Header>

      <Modal.Body>
        {/* Bandeau résumé */}
        <div className="recap-hero">
          <div className="recap-hero-left">
            <div className="recap-route">
              <div className="recap-route-item">
                <span className="recap-dot" />
                <div>
                  <div className="recap-label">Départ</div>
                  <div className="recap-value">{depart || "—"}</div>
                </div>
              </div>

              <div className="recap-route-line" />

              <div className="recap-route-item">
                <span className="recap-dot recap-dot-end" />
                <div>
                  <div className="recap-label">Arrivée</div>
                  <div className="recap-value">{arrivee || "—"}</div>
                </div>
              </div>
            </div>

            <div className="recap-meta">
              <div className="recap-meta-item">
                <div className="recap-label">Date</div>
                <div className="recap-value">{date || "—"}</div>
              </div>
              <div className="recap-meta-item">
                <div className="recap-label">Heure</div>
                <div className="recap-value">{heure || "—"}</div>
              </div>
              <div className="recap-meta-item">
                <div className="recap-label">Service</div>
                <div className="recap-value">{serviceType || "—"}</div>
              </div>
            </div>
          </div>

          <div className="recap-hero-right">
            <div className="recap-kpis">
              <div className="recap-kpi">
                <div className="recap-kpi-label">Distance</div>
                <div className="recap-kpi-value">
                  {distance ? `${distance} km` : "—"}
                </div>
              </div>
              <div className="recap-kpi">
                <div className="recap-kpi-label">Durée</div>
                <div className="recap-kpi-value">
                  {duree ? `${duree} min` : "—"}
                </div>
              </div>
              <div className="recap-kpi recap-kpi-price">
                <div className="recap-kpi-label">Prix estimé</div>
                <div className="recap-kpi-value">
                  {prix ? `${prix} €` : "—"}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Row className="g-3 mt-2">
          {/* Passager */}
          <Col md={6}>
            <div className="recap-card">
              <div className="recap-card-title">Informations passager</div>

              <div className="recap-pairs">
                <div className="recap-pair">
                  <div className="recap-label">Nom</div>
                  <div className="recap-value">{name || "—"}</div>
                </div>
                <div className="recap-pair">
                  <div className="recap-label">Prénom</div>
                  <div className="recap-value">{firstname || "—"}</div>
                </div>
                <div className="recap-pair">
                  <div className="recap-label">Email</div>
                  <div className="recap-value">{email || "—"}</div>
                </div>
                <div className="recap-pair">
                  <div className="recap-label">Téléphone</div>
                  <div className="recap-value">{phone || "—"}</div>
                </div>
              </div>
            </div>
          </Col>

          {/* Course */}
          <Col md={6}>
            <div className="recap-card">
              <div className="recap-card-title">Détails de la course</div>

              <div className="recap-pairs">
                <div className="recap-pair">
                  <div className="recap-label">Passagers</div>
                  <div className="recap-value">{passagers ?? "—"}</div>
                </div>
                <div className="recap-pair">
                  <div className="recap-label">Bagages</div>
                  <div className="recap-value">{bagages ?? "—"}</div>
                </div>

                <div className="recap-pair">
                  <div className="recap-label">Options</div>
                  <div className="recap-value">
                    {activeOptions.length ? (
                      <div className="recap-badges">
                        {activeOptions.map((o) => (
                          <Badge key={o.key} className="recap-badge">
                            {o.label}
                          </Badge>
                        ))}
                      </div>
                    ) : (
                      "Aucune"
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* Demandes */}
          <Col md={12}>
            <div className="recap-card">
              <div className="recap-card-title">Demandes spécifiques</div>
              <div className="recap-free">
                {demandes?.trim() ? demandes : "Aucune demande particulière."}
              </div>
            </div>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => navigate("/")}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
